<template>
  <div class="comingSoon">
    <div class="comingSoon__image-first">
      <img src="/img/newhome/comming-soon-1.png" alt="">
    </div>
    <div class="mobile-image1">
      <img src="/img/newhome/comming-soon-2.png" alt="">
    </div>
    <div class="comingSoon__content__wrapper">
      <div class="comingSoon__content__wrapper__header">
        <div class="mobile-image2">
          <img src="/img/newhome/comming-soon-1.png" alt="">
        </div>
        <div class="text">
          <div class="coming">
            COMING
          </div>
          <div class="soon">
            SOON
          </div>
        </div>
      </div>
      <div class="comingSoon__content__wrapper__footer">
        <div class="title">
          Something Awesome are in progress
        </div>
        <div class="code">
          be the first to advertise on this channel
        </div>
        <div class="action">
          <button class="btn-large primary" @click="goContactUs">Contact Us</button>
        </div>
      </div>
    </div>
    <div class="comingSoon__image-second">
      <img src="/img/newhome/comming-soon-2.png" alt="">
    </div>
  </div>
</template>

<script>

export default {
  name: 'adx-coming-soon',
  components: {

  },
  props: {

  },
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    goContactUs() {
      this.$router.push({name: 'contactus'})
    }
  }
}
</script>

<style lang='scss'>
@import './index.scss';

  @include breakpoint(md) {
    .container{
      .menubar{
        &__mobile{
          display: none;
          z-index: 0;
        }
      }
    }
  }
</style>